import React from "react";
import "./Table.scss";

const Table = ({ data = {}, activeTab = "Table" }) => {
  // Ensure data is not null or undefined
  if (!data || Object.keys(data).length === 0) {
    return <p>No data available</p>;
  }

  // Extract years from the keys of the first item in the data array
  const years = Object.keys(data);

  // Generate table headers
  const headers = ["Particulars", ...years];

  // Prepare the data for rendering
  const rowsData =
    years.length > 0
      ? Object.keys(data[years[0]] || {}).map((particular) => {
          return {
            particular,
            values: years.map((year) => data[year]?.[particular] ?? "-"),
          };
        })
      : [];

  return (
    <>
      <div className="tab-name-header">
        <h6 className="table-header">{activeTab}</h6>
      </div>
      <div className="table-section">
        <table className="table table-striped">
          <thead>
            <tr>
              <th style={{ width: "40px" }}>S.No</th>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rowsData.map((row, index) => (
              <tr key={index}>
                <td style={{ width: "40px" }}>{index + 1}</td>
                <td className="row-title" >{row.particular}</td>
                {row.values.map((value, index) => (
                  <td key={index}>
                    {value !== null && value !== undefined ? value : "-"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Table;
